import fetch from "cross-fetch";

export const JSON_FETCHER = (url: any) =>
  fetch(url, {
    method: "GET",
    headers: {
      "X-TimeZone": Intl.DateTimeFormat().resolvedOptions().timeZone || "Etc/UTC",
    },
  }).then((res) => res.json());
